import { render, staticRenderFns } from "./TabsSquare.vue?vue&type=template&id=59343c02&"
import script from "./TabsSquare.vue?vue&type=script&lang=js&"
export * from "./TabsSquare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports